// Every word the one shared order bump prints of its own, gathered here the way `checkoutLabels.ts`
// gathers the COD card's. The bump had its wording baked into the component in French, on the highest
// margin element on the page, in a product that sells in Arabic and French — so a shop in Arabic could
// not translate the one line that closes the sale. The offer's own title, description and prices are
// not here: those come from the server and belong to the offer, not to this component.

/** The bump's own wording, one key per string it draws. */
export type UpsellBumpLabels = {
  /** A line above the card. Empty by default, because the unthemed storefront never drew one. */
  heading: string;
  /** A line under the heading. Empty by default, for the same reason. */
  pitch: string;
  /** The opt-in wording beside the tick. Empty by default: the card itself has always been the label. */
  checkboxLabel: string;
  acceptedText: string;
  savingsPrefix: string;
};

/** What the storefront has always printed; a caller that passes none still reads exactly like this. */
export const DEFAULT_UPSELL_BUMP_LABELS: UpsellBumpLabels = {
  heading: '',
  pitch: '',
  checkboxLabel: '',
  acceptedText: 'Ajouté à votre commande. Décochez pour le retirer.',
  savingsPrefix: 'Économisez'
};

// Fills every word a caller did not supply with the wording the unthemed storefront already printed.
export const resolveUpsellBumpLabels = (overrides?: Partial<UpsellBumpLabels>): UpsellBumpLabels => {
  const resolved: UpsellBumpLabels = { ...DEFAULT_UPSELL_BUMP_LABELS };
  if (!overrides) return resolved;
  for (const key of Object.keys(DEFAULT_UPSELL_BUMP_LABELS) as readonly (keyof UpsellBumpLabels)[]) {
    const value = overrides[key];
    if (typeof value === 'string' && value.length > 0) resolved[key] = value;
  }
  return resolved;
};

// Picks the words the shared card prints inside itself out of a theme's own bump settings.
export const bumpWordsOf = (
  settings: Pick<UpsellBumpLabels, 'checkboxLabel' | 'acceptedText' | 'savingsPrefix'>
): Partial<UpsellBumpLabels> => ({
  checkboxLabel: settings.checkboxLabel,
  acceptedText: settings.acceptedText,
  savingsPrefix: settings.savingsPrefix
});
